import React from "react";
import { Toggle } from "../../../atoms";
import { RecommendationVariant, RecommendationItem } from "../types";
import styles from "./index.style.module.css";

interface ContentRecommendationTileProps {
  variant?: RecommendationVariant;
  label?: string;
  recommendations: RecommendationItem[];
  onToggle?: (id: string, selected: boolean) => void;
  className?: string;
}

const variantConfig = {
  [RecommendationVariant.INFO]: {
    backgroundClass: "INFO",
  },
  [RecommendationVariant.WARNING]: {
    backgroundClass: "WARNING",
  },
  [RecommendationVariant.BLOCKER]: {
    backgroundClass: "BLOCKER",
  },
};

const ContentRecommendationTile: React.FC<ContentRecommendationTileProps> = ({
  variant = RecommendationVariant.INFO,
  label,
  recommendations,
  onToggle,
  className = "",
}) => {
  const config = variantConfig[variant];

  const handleToggle = (id: string, checked: boolean) => {
    if (onToggle) {
      onToggle(id, checked);
    }
  };

  return (
    <div
      className={`${styles.tile} ${styles[config.backgroundClass]} ${className || ""}`}
    >
      {recommendations.map((rec, index) => (
        <div key={rec.id} className={styles.itemWrapper}>
          <div className={styles.itemContent}>
            {index === 0 && label && (
              <div className={styles.labelContainer}>
                <span className={styles.label}>{label}</span>
              </div>
            )}

            <div className={styles.contentRow}>
              <div className={styles.textContent}>
                <p className={styles.description}>{rec.description}</p>
              </div>

              <Toggle
                checked={rec.isSelected || false}
                onChange={(checked) => handleToggle(rec.id, checked)}
                isDisabled={rec.isDisabled}
                uniqueKey={rec.id}
              />
            </div>
          </div>

          {index < recommendations.length - 1 && (
            <div className={styles.divider}></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ContentRecommendationTile;
